import { combineReducers } from 'redux';
// Import reducers
import content_translations_data from './content_translations_data_reducer';
import language_list from './content_translations_language_list_reducer';

export default combineReducers({
	content_translations_data,
	language_list
});
